import { render, staticRenderFns } from "./RiskFactorEditDialog.vue?vue&type=template&id=614298eb&"
import script from "./RiskFactorEditDialog.vue?vue&type=script&lang=js&"
export * from "./RiskFactorEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports